import { ApiError } from '@/lib/api';
import type { EvaluatedAlert } from '@merkos-mgmt/shared';

export interface TrippedTimeAlerts {
  /** Block rules: the action is refused until the entry no longer breaks them. */
  blocked: EvaluatedAlert[];
  /** Alert-only rules: the action may go ahead once the user acknowledges them. */
  warnings: EvaluatedAlert[];
}

/**
 * The time rules a 409 from a time action reported (`blocked` or
 * `requiresAcknowledgement` + `warnings`), or null when the error is anything else.
 */
export function timeAlertsFromError(err: unknown): TrippedTimeAlerts | null {
  if (!(err instanceof ApiError) || err.status !== 409) return null;
  if (!err.data.blocked && !err.data.requiresAcknowledgement) return null;
  return {
    blocked: (err.data.blocked as EvaluatedAlert[] | undefined) ?? [],
    warnings: (err.data.warnings as EvaluatedAlert[] | undefined) ?? [],
  };
}

/** One line per rule, for a toast or a confirm. */
export function alertLines(alerts: EvaluatedAlert[]): string {
  return alerts.map((a) => a.message || a.ruleName).join('; ');
}
